// @flow
import styled, { css } from 'styled-components';
import DefaultTheme from '.';
import ShipaDeliverySelectTheme from '../../select/theme/shipa-delivery';
import { sd300, silverGrey, errorText } from '../../colors';
/*::
import type { PhoneInputThemeType } from '../';
*/

var theme
/*: PhoneInputThemeType */
= Object.assign({}, DefaultTheme, {
  Main: styled(DefaultTheme.Main).withConfig({
    displayName: "shipa-delivery__Main",
    componentId: "aicumc-0"
  })(["&:after{background-color:", ";}"], function (pr) {
    return pr.focused ? sd300() : silverGrey();
  }),
  Select: ShipaDeliverySelectTheme,
  SelectFormElement: Object.assign({}, DefaultTheme.SelectFormElement, {
    Label: styled(DefaultTheme.SelectFormElement.Label).withConfig({
      displayName: "shipa-delivery__Label",
      componentId: "aicumc-1"
    })(["", ""], function (pr) {
      return pr.focused ? css(["color:", ";"], pr.error ? errorText() : sd300()) : '';
    })
  }),
  InputFormElement: Object.assign({}, DefaultTheme.InputFormElement, {
    Label: styled(DefaultTheme.InputFormElement.Label).withConfig({
      displayName: "shipa-delivery__Label",
      componentId: "aicumc-2"
    })(["", ""], function (pr) {
      return pr.focused ? css(["color:", ";"], pr.error ? errorText() : sd300()) : '';
    }),
    Required: styled(DefaultTheme.InputFormElement.Required).withConfig({
      displayName: "shipa-delivery__Required",
      componentId: "aicumc-3"
    })(["color:", ";"], sd300())
  }),
  InputComponent: Object.assign({}, DefaultTheme.InputComponent, {
    Input: styled(DefaultTheme.InputComponent.Input).withConfig({
      displayName: "shipa-delivery__Input",
      componentId: "aicumc-4"
    })(["&:focus{border-bottom:1px solid ", ";}"], function (pr) {
      return pr.error ? errorText() : sd300();
    })
  })
});
export default theme;